// 环境配置文件
// 根据不同的环境提供不同的API URL

// 获取当前域名的基础URL
function getDomainBaseUrl() {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // 检测访问域名
    if (hostname.includes('xiaobangkeyan.com')) {
      return 'https://api.xiaobangkeyan.com';
    } else if (hostname.includes('sainanecv.com')) {
      return 'https://api.sainanecv.com';
    }
  }
  
  // 默认返回sainanecv.com的API
  return 'https://api.sainanecv.com';
}

const environments = {
  // 开发环境
  development: {
    apiUrl: 'http://localhost:8081'
  },
  
  // 测试环境
  testing: {
    apiUrl: 'http://test-api.example.com'
  },
  
  // 生产环境 - 动态检测当前域名
  production: {
    get apiUrl() {
      return getDomainBaseUrl();
    }
  }
}

// 默认使用development环境
let currentEnv = 'development'

// 根据NODE_ENV判断当前环境
if (process.env.NODE_ENV === 'production') {
  // 生产构建时根据构建命令中的环境变量确定使用哪个生产配置
  currentEnv = process.env.VUE_APP_MODE || 'production'
}

console.log('当前环境:', currentEnv)

export default environments[currentEnv] 